import { ComboboxData, ComboboxItem } from '@mantine/core';
import { useGetEnums } from 'api-hooks/common';
import { EnumList } from 'common/constants/enum';
import { capitalize } from 'common/utils/string';
import Input from 'mantine-components/elements';
import * as React from 'react';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  enumType: EnumList;
  clearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  hideRequiredStar?: boolean;
  hideLabel?: boolean;
  fieldType?: 'control' | 'uncontrol';
  onAfterChange?: (value: string | null, option: ComboboxItem) => void;
}

export default function EnumSelectInput(props: Props) {
  const { enumType, ...rest } = props;
  const { data, isLoading } = useGetEnums({ class: enumType });

  const uppercaseWord = React.useMemo(() => ['pt', 'cv'], []);

  const options = React.useMemo<ComboboxData>(() => {
    return (data?.data || []).map((item) => ({
      value: item.value,
      label: uppercaseWord.find((word) => word === item.value)
        ? item.value.toUpperCase()
        : capitalize(item.label),
    }));
  }, [data, uppercaseWord]);

  return (
    <Input
      type="select"
      {...rest}
      onChange={rest.onAfterChange}
      data={options}
      disabled={isLoading || rest.disabled}
    />
  );
}
